import React from "react";

/**
 * ArrowLeftIcon — MangoTV Design System
 * Figma: Arrow-Left component (24654:4386)
 * 36x36 icon used for back navigation
 */
const ArrowLeftIcon = ({ size = 36, color = "#fafafa" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 12H5M5 12L12 19M5 12L12 5"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowLeftIcon;
